import { render } from "./VehicleParameters.vue?vue&type=template&id=5bdb29bb"
import script from "./VehicleParameters.vue?vue&type=script&lang=js"
export * from "./VehicleParameters.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./VehicleParameters.vue?vue&type=style&index=0&id=5bdb29bb&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__